import React from 'react';
import { RESERVATION_STATUSES, CALENDAR_BLOCK_TYPES } from './reservationStatus';

/**
 * ReservationLegend — swatch + label key for calendar statuses and block types.
 * Presentational; reads from the shared status registry.
 *
 * Props:
 *   includeBlocks: boolean   — also show non-reservation overlays (default true)
 */
const ReservationLegend = ({ includeBlocks = true, className = '' }) => {
  const items = [
    ...RESERVATION_STATUSES,
    ...(includeBlocks ? CALENDAR_BLOCK_TYPES : []),
  ];
  return (
    <div className={`ps-rlegend ${className}`.trim()}>
      {items.map((item) => (
        <div className="ps-rlegend__item" key={item.key}>
          <span className={`ps-rlegend__swatch ps-rtile--${item.key}`} aria-hidden="true" />
          <span className="ps-rlegend__label">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default ReservationLegend;
